<template>
  <div class="create-ticket-description-container-xs">
    <div class="d-flex mb-3">
      <div>
        <img src="../assets/message-icon.svg" alt="" class="me-3" />
      </div>
      <span class="text-start color-primary mb-0">
        Write your problem in the section below; our support team will be in touch very
        soon!
      </span>
    </div>
    <div class="mb-2 position-relative">
      <input
        v-model="subject"
        type="text"
        placeholder="Subject"
        :class="subjectInputClass"
        class="d-inline-block"
        @input="handleSubjectChanges"
      />
      <span>
        <div class="">
          <button
            v-if="categoryMenuStatus === 'collapse'"
            class="create-ticket-category-btn-collapse-xs"
            @click="categoryMenuStatus = 'expand'"
          >
            <p
              :class="[
                selectedCategory === ''
                  ? 'fsz-14 third-color'
                  : 'fsz-14 fw-bold primary-color',
              ]"
            >
              {{ selectedCategory === "" ? "Select Category" : selectedCategory }}
            </p>
            <i class="icon-chevron-down fsz-10"></i>
          </button>
          <div
            v-if="categoryMenuStatus !== 'collapse'"
            class="position-absolute create-ticket-category-expand-xs"
          >
            <button
              class="bg-transparent w-100 border-0 outline-0 d-flex justify-content-between align-items-center px-3 py-3"
              @click="categoryMenuStatus = 'collapse'"
            >
              <p
                :class="[
                  selectedCategory === ''
                    ? 'fsz-14 third-color'
                    : 'fsz-14 fw-bold accent-color',
                ]"
              >
                {{ selectedCategory === "" ? "Select Category" : selectedCategory }}
              </p>
              <i class="icon-chevron-up fsz-10"></i>
            </button>
            <hr class="my-0 mx-3 category-separator" />
            <ul>
              <li
                v-for="(category, index) in categories"
                :key="index"
                :class="[
                  selectedCategory === category.name
                    ? 'fsz-14 accent-color fw-bold'
                    : 'fsz-14 third-color ',
                ]"
                @click="selectCategory(category)"
              >
                {{ category.name }}
              </li>
            </ul>
          </div>
        </div>
      </span>
    </div>
    <textarea
      v-model="dsecription"
      placeholder="Describe your issue here ..."
      :class="textareaClass"
      @input="handleDescriptionChanges"
    ></textarea>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      subject: "",
      dsecription: "",
      categoryMenuStatus: "collapse",
      selectedCategory: "",
    };
  },
  computed: {
    ...mapState({
      categories: (state) => state.createTicketStore.ticketCategories,
    }),
    subjectInputClass() {
      return this.subject === ""
        ? "create-ticket-input-empty-xs"
        : "create-ticket-input-fill-xs";
    },
    textareaClass() {
      return this.dsecription === ""
        ? "create-ticket-textarea-empty-xs"
        : "create-ticket-textarea-fill-xs";
    },
  },

  methods: {
    ...mapMutations("createTicketStore", [
      "HANDLE_DESCRIPTION",
      "HANDLE_SUBJECT",
      "HANDLE_CATEGORY_ID",
    ]),
    selectCategory(category) {
      this.selectedCategory = category.name;
      this.categoryMenuStatus = "collapse";
      this.HANDLE_CATEGORY_ID(category.id);
    },
    handleSubjectChanges(event) {
      this.HANDLE_SUBJECT(event.target.value);
    },
    handleDescriptionChanges(event) {
      this.HANDLE_DESCRIPTION(event.target.value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/DescriptionXs.scss";
.category-separator {
  border: 1px solid #eaeaea;
}
</style>
